<template>
  <ETourActivityAds
    v-if="show"
    v-bind="{ ...$attrs, ...$props }"
    page-position="mainline"
    v-on="$listeners"
  />
</template>

<script>
import screen from '~~/common/vue/mixins/screen';
import ETourActivityAds from './index';

export default {
  name: 'ETourActivityAdsMainline',
  components: {
    ETourActivityAds,
  },
  mixins: [screen],
  props: ETourActivityAds.props,
  data() {
    return {
      // purposely inactive on mainline for the current scope and
      // will be activated after first successful experiment
      active: false,
    };
  },
  computed: {
    show() {
      return !this.isDesktopUp && this.active;
    },
  },
};
</script>
